import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, HostListener, Input } from '@angular/core';
import { DynamicModule } from 'ng-dynamic-component';

@Component({
  selector: 'app-mobile-mega-menu',
  imports: [NgFor, NgIf, NgClass, DynamicModule],
  templateUrl: './mobile-mega-menu.component.html',
  styleUrl: './mobile-mega-menu.component.scss',
})
export class MobileMegaMenuComponent {
  @Input() _editable!: string;
  @Input() _uid!: string;
  @Input() component!: string;
  @Input() _active: boolean = false;

  @Input() label!: string;
  @Input() menus!: any;

  components: any;

  _menu: any;

  constructor() {
    import('src/app/storyblok/components').then((cp) => {
      this.components = cp.Components;
    });
  }

  @HostListener('document:click', ['$event'])
  clickout(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }
}
